'use strict'

export const GET_ASSIGNMENTS = 'assignments/GET_ASSIGNMENTS';
export const GET_ASSIGNMENTS_COMPLETED = 'assignments/GET_ASSIGNMENTS_COMPLETED';
export const REORDER_ASSIGNED = 'assignments/REORDER_ASSIGNED';
